import React, { useEffect, useState } from "react";
import PurchasePage from "../../../../../entities/DashboardPage/AccountingModule/Purchase/PurchaseHome";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";

const Purchase = () => {

  const [data, setData] = useState([]);
  const [count,setCount] = useState();
  const [page,setPage] = useState(1);
  useEffect(() => {
    getPurchases();
  }, [])
  const getPurchases = async (text,sort,page) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getPurchase(text,sort,page);
      if (result?.success) {
        setData(result?.data?.purchases);
        setCount(result?.data?.total)
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const handleSearch = (text,sort) =>{
    text ? getPurchases(text):sort?getPurchases("",sort):null
  }

  return (
    
    <PurchasePage count={count}page={page}setPage={setPage} data={data}  handleSearch={handleSearch}/>
  )


}

export default Purchase;
